'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

import { useAuth } from '~/providers/auth-provider'

export const HomeRedirect = () => {
	const router = useRouter()
	const { isLoading, isAuth } = useAuth()

	useEffect(() => {
		if (isAuth && !isLoading) {
			router.push('/dashboard')
		}
	}, [isAuth, isLoading, router])

	return null
}
